import { render, staticRenderFns } from "./Jaanallaonasiaa.vue?vue&type=template&id=1eddc689&scoped=true"
var script = {}
import style0 from "./Jaanallaonasiaa.vue?vue&type=style&index=0&id=1eddc689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eddc689",
  null
  
)

export default component.exports